module.exports = __webpack_public_path__ + "img/1544592902.e8a48c33.jpg";